// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"fc5fcba0b69439e2","5763":"7f6d84e817ed33c2","7222":"750aec4ea4ef1d02","7937":"debdd0bcdaa6e2c0"}[chunkId] + ".js";
};